import React, { useState } from "react";
import { useLoader } from "../../utils/LoaderUtils";
import SEOFields from "../../components/partials/SEOFields";
import slugify from "slugify";
import SEO_CONSTANTS from "../../constants/seoConstants";

function AddNew() {
  const [errors, setErrors] = useState({});
  const { showLoader, hideLoader } = useLoader();
  const [isLoading, setIsLoading] = useState(false);

  const INITIAL_FORM_DATA = {
    path: "",
  };

  const SEO_FORM_DATA = {
    metaTitle: "",
    metaDescription: "",
    tags: [],
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [seoData, setSeoData] = useState(SEO_FORM_DATA);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.path) {
      newErrors.path = "Title is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    showLoader();

    if (!validate()) {
      setIsLoading(false);
      hideLoader();
      return;
    }

    // try {
    //   const res = await CouponAPI.addDetails(formData);

    //   if (res.code === 200) {
    //     showSuccess(res.message);
    //     setFormData(INITIAL_FORM_DATA);
    //   } else {
    //     showError(res.message);
    //   }
    // } catch (err) {
    //   handleApiValidationError(err, setErrors);
    // }

    setIsLoading(false);
    hideLoader();
  };

  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Add Page SEO</h4>
            <h6>Set up seo for pages to boost your website.</h6>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h4>Add SEO Details</h4>
          </div>
          <div className="card-body profile-body">
            <form method="post" onSubmit={handleSubmit}>
              <div className="row mb-3">
                <div className="col-lg-3 col-sm-6">
                  <label className="form-label">Title</label>
                  <select
                    className="form-select"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                  >
                    <option value="">Select Page</option>

                    {Object.keys(SEO_CONSTANTS).map((key) => (
                      <option key={key} value={key}>
                        {key.replace(/([A-Z])/g, " $1").trim()}
                      </option>
                    ))}
                  </select>
                </div>
                {errors.minimumCartValue && (
                  <span className="errors text-danger">
                    {errors.minimumCartValue}
                  </span>
                )}
              </div>

              <SEOFields
                seoData={seoData}
                setSeoData={setSeoData}
                slug={SEO_CONSTANTS[formData.title] || ""}
                errors={errors}
              />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddNew;
